'use client';
import Link from 'next/link';

import Button from '@/components/v2/Button';
import Image from '@/components/v2/Image';
import ArrowRight from '@/icons/ArrowRight';
import Refresh from '@/icons/Refresh';

import HistoryBackButton from './_components/Back';

const ErrorPage = ({ reset, error }: { error: Error & { digest?: string }; reset: () => void }) => {
  return (
    <div className="w-dvw h-dvh flex">
      <div className="flex flex-col items-center m-auto md:flex-row md:gap-[88px] md:items-start px-8">
        <div className="block">
          <Image src={'/img/error/error_mong.png'} width={127} height={154} alt={'error_mong'} />
        </div>
        <div className="text-center md:text-left">
          <h1 className="text-[50px] md:text-[96px] font-black leading-[100px]">ERROR</h1>
          <p className="mt-2 text-[18px] md:text-5xl">에러가 발생했어요 ㅠㅠ</p>

          <p className="text-gray-2 text-[16px] mt-4 md:text-xl md:my-6">
            잠시 후 다시 시도해주세요
            <br />
            에러가 지속되면 채팅상담으로 문의해주세요.
          </p>

          <p className="mt-4 md:mt-8 text-gray-2 text-left">
            에러 메세지: {error?.digest} {error?.message}
          </p>

          <div className="flex gap-2 md:gap-4 max-w-full mt-4">
            <HistoryBackButton />

            <Link href={'/'}>
              <Button variant={'gray'} className="w-[180px] h-11 hidden md:flex">
                댓글몽 바로가기 <ArrowRight />
              </Button>
            </Link>
            <Button
              variant={'tonalsecondary'}
              color="secondary"
              onClick={reset}
              className="w-[140px] md:w-[180px] px-0"
            >
              재시도 <Refresh />
            </Button>
          </div>
          <div className="md:hidden mt-4">
            <Link href={'/'}>
              <Button variant={'gray'} className="w-[160px] md:hidden">
                댓글몽 바로가기 <ArrowRight className="size-4" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
